var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Download",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 22,
    viewBox: "0 0 24 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M28,24V20a1,1,0,0,0-2,0v4a1,1,0,0,1-1,1H7a1,1,0,0,1-1-1V20a1,1,0,0,0-2,0v4a3,3,0,0,0,3,3H25a3,3,0,0,0,3-3Zm-6.38-5.22-5,4a1,1,0,0,1-1.24,0l-5-4a1,1,0,0,1,1.24-1.56L15,19.92V6a1,1,0,1,1,2,0V19.92l3.38-2.7a1,1,0,1,1,1.24,1.56Z",
    transform: "translate(-4 -5)",
    fill: "#005db4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.aeb36f4fc0488d65071ab6a113b6940f.svg";
export { ForwardRef as ReactComponent };